import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { PostmarkSuccess, Field } from "./FormBits";

export const StayUpdatedForm = () => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/forms/stay-updated", form);
      setDone(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done)
    return (
      <PostmarkSuccess
        title="You're On The List!"
        message="We'll send lineup announcements, schedule details etc. straight to your inbox."
        onReset={() => { setForm({ name: "", email: "" }); setDone(false); }}
        resetLabel="Add Another"
      />
    );

  return (
    <form onSubmit={submit} className="max-w-xl mx-auto space-y-6" data-testid="stay-updated-form">
      <p className="font-mono text-sm text-forest-light text-center">
        Get event updates — lineup announcements, schedule details, and how to enter the Inaam Ghar lucky draws.
      </p>
      <Field label="Full Name" required>
        <input className="vintage-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" data-testid="stay-name" />
      </Field>
      <Field label="Email" required>
        <input type="email" className="vintage-input" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@email.com" data-testid="stay-email" />
      </Field>
      <button type="submit" disabled={busy} className="btn-rust w-full py-4 text-base disabled:opacity-60" data-testid="stay-submit">
        {busy ? "Sending…" : "Keep Me Posted"}
      </button>
    </form>
  );
};
